"use strict";

exports.__esModule = true;
exports.drawEllipse = exports.default = void 0;
var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);

var drawEllipse = function drawEllipse(ctx, cx, cy, rx, ry) {
  var x = cx - rx;
  var y = cy - ry;
  var ox = rx * KAPPA;
  var oy = ry * KAPPA;
  var xe = x + rx * 2;
  var ye = y + ry * 2;
  var xm = x + rx;
  var ym = y + ry;
  ctx.moveTo(x, ym);
  ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
  ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
  ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
  ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
  ctx.closePath();
};

exports.drawEllipse = drawEllipse;

var renderEllipse = function renderEllipse(ctx, node) {
  var _ref = node.props || {},
      cx = _ref.cx,
      cy = _ref.cy,
      rx = _ref.rx,
      ry = _ref.ry;

  drawEllipse(ctx, cx, cy, rx, ry);
};

var _default = renderEllipse;
exports.default = _default;